<!--This component is purely aesthetic and shows a parallax image.
    Requires:
    - Image (of certain size)
    - Choice for whether image is takes up half of page or whole page.
-->
<template>
  <mdb-parallax
    :src="`${block.value.image.original.src}`"
    height="half"
    factor="1.3"
    class="z-depth-4"
  ></mdb-parallax>
</template>
          
        
<script>
import { mdbParallax } from "mdbvue";
export default {
  name: "parallax_image",
  props: {
    block: Object
  },
  components: {
    mdbParallax
  }
};
</script>